{
  "heroTitle": "Arkadaşlarını davet et",
  "heroSub": "Her başarılı davette {{bonus}} bonus bakiyeye yazılır. Arkadaşın yatırım yapınca tutarın %{{percent}} kadarı {{days}} gün sonra gerçek bakiyene geçer — istediğin zaman çekebilirsin.",
  "yourLink": "Davet linkin",
  "linkHint": "Bu bir Telegram bot linkidir. Arkadaşın linki açınca botuna senin davetinle katılır.",
  "copy": "Kopyala",
  "copied": "Kopyalandı",
  "share": "Paylaş",
  "more": "Daha fazla",
  "shareText": "VBB PLAY botuna katıl! Davet başına {{bonus}} bonus, arkadaşının yatırımından da %{{percent}} kazanç sana kalır.",
  "infoTitle": "Bilgi",
  "infoSignup": "Davet ettiğin her arkadaş için {{bonus}} hemen bonus bakiyene yazılır. Yalnızca bonus oyunlarında kullanılır; gerçek bakiyeye karışmaz ve doğrudan çekilemez.",
  "infoBonusGames": "Bonus oyunları: Menüden Bonus oyunlarına gir. Oyunu bonus bakiye ile başlat. Kazançlar çevrim şartları tamamlanana kadar bonusda kalır; gerçek paralı oturumlar bu bonusu harcamaz.",
  "infoDeposit": "Davet ettiğin arkadaş onaylı yatırım yapınca tutarın %{{percent}} kadarı komisyonun olarak kaydedilir. Örnek: arkadaş {{exampleDeposit}} yatırırsa, sana {{exampleCommission}} düşer.",
  "infoHold": "Yatırım komisyonu {{days}} gün sonra otomatik gerçek bakiyeye geçer. Bu süre boyunca bekleyen olarak görünür.",
  "infoWithdraw": "Gerçek bakiyeye geçen tutarı Kasa üzerinden platform kurallarına göre çekebilirsin.",
  "infoUnique": "Her oyuncunun kendine özel davet linki vardır. Kendi kendini davet etmek mümkün değildir.",
  "invitedLabel": "Davet ettiklerin",
  "friendsUnit": "arkadaş",
  "earningsLabel": "Davetten kazancın",
  "earningsSplit": "bonus {{bonus}} · gerçek {{real}}",
  "earningsPending": "beklemede {{amount}} ({{days}} gün)",
  "friendsTitle": "Arkadaşların",
  "friendsCount": "{{count}} kişi",
  "friendsEmpty": "Henüz kimseyi davet etmedin",
  "friendId": "ID: {{id}}",
  "friendDeposit": "Yatırım: {{amount}}",
  "friendEarned": "Sana: {{amount}}",
  "friendPending": "Beklemede: {{amount}}",
  "friendPendingUntil": "{{date}} tarihinde gerçeğe geçer",
  "loginRequired": "Davet linkini görmek için giriş yap.",
  "navLabel": "Arkadaş daveti"
}
